module.exports = __webpack_public_path__ + "img/menu-about-icon.36354a56.svg";